<template>
    <div>
        <job-report-list></job-report-list>
    </div>
</template>
<script>
export default {}
</script>
    